module.exports = __webpack_public_path__ + "img/marker-alt-master.svg?b1abfb7727e94ad39edb7f3b9b0d039a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/maps/marker-alt-master.svg
// module id = 299
// module chunks = 0